import { useDispatch, useSelector } from "react-redux";

import { IAppState } from "../../../store/reducers";
import { useNavigate } from "react-router-dom";

// import { clearSelectedResourceApiMessageActions } from "store/actions/resourceApiMessageActions";
export const CompanyMenuComponent = () => {
  const clientId = useSelector((state: IAppState) => state.client.id);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ArrayData = [
    {
      label: "Setup",
      command: () => {
        navigate(`/clients/setup/${clientId}`)
      },
    },
    {
      label: "Bank",
      command: () => {
        navigate("/clients/bank-setup")
      },
    },
    {
      label: "Payroll Schedule",
      command: () => {
        navigate("/company/payroll-schedule")
      },
    },
    {
      label: "Filing Resource",
      command: () => {
        navigate("/company/filing-resources/setup")
      },
      // items: [
      //   {
      //     label: "List",
      //     command: () => {
      //       navigate("/company/filing-resources/list")
      //     },
      //   },
      //   {
      //     label: "Setup",
      //     command: () => {
      //       navigate("/company/filing-resources/setup")
      //     },
      //   }
      // ],  
    },
    {
      label: "Departments",
      command: () => {
        navigate("/company/departments/setup")
      },
      // items: [
      //   {
      //     label: "List",
      //     command: () => {
      //       navigate("/company/departments/list")
      //     },
      //   },
      //   {
      //     label: "Setup",
      //     command: () => {
      //       navigate("/company/departments/setup")
      //     },
      //   },
      // ]
    },
    {
      label: "Designation",
      command: () => {
        navigate("/company/designation/setup")
      },
      // items: [
      //   {
      //     label: "List",
      //     command: () => {
      //       navigate("/company/designation/list")
      //     },
      //   },
      //   {
      //     label: "Setup",
      //     command: () => {
      //       navigate("/company/designation/setup")
      //     },
      //   },
      // ]
    },
    {
      label: "Locations",
      command: () => {
        navigate("/company/locations/setup")
      },
      // items: [
      //   {
      //     label: "List",
      //     command: () => {
      //       navigate("/company/locations/list")
      //     },
      //   },
      //   {
      //     label: "Setup",
      //     command: () => {
      //       navigate("/company/locations/setup")
      //     },
      //   },
      // ]
    },
    {
      label: "Teams",
      command: () => {
        navigate("/company/teams/setup")
      },
      // items: [
      //   {
      //     label: "List",
      //     command: () => {
      //       navigate("/company/teams/list")
      //     },
      //   },
      //   {
      //     label: "Setup",
      //     command: () => {
      //       navigate("/company/teams/setup")
      //     },
      //   },
      // ]
    },
    {
      label: "Expense Category",
      command: () => {
        navigate("/company/expense-category/setup")
      },
      // items: [
      //   {
      //     label: "List",
      //     command: () => {
      //       navigate("/company/expense-category/list")
      //     },
      //   },
      //   {
      //     label: "Setup",
      //     command: () => {
      //       navigate("/company/expense-category/setup")
      //     },
      //   },
      // ]
    },
    // {
    //   label: "Deductions",
    //   items: [
    //     {
    //       label: "List",
    //       command: () => {
    //         navigate("/company/deductions/list")
    //       },
    //     },
    //     {
    //       label: "Setup",
    //       command: () => {
    //         navigate("/company/deductions/setup")
    //       },
    //     },
    //   ]
    // },
    // {
    //   label: "Reimbursements",
    //   items: [
    //     {
    //       label: "List",
    //       command: () => {
    //         navigate("/company/reimbursements/list")
    //       },
    //     },
    //     {
    //       label: "Setup",
    //       command: () => {
    //         navigate("/company/reimbursements/setup")
    //       },
    //     },
    //   ]
    // },
    // {
    //   label: "Earnings",
    //   items: [
    //     {
    //       label: "List",
    //       command: () => {
    //         navigate("/company/earnings/list")
    //       },
    //     },
    //     {
    //       label: "Setup",
    //       command: () => {
    //         navigate("/company/earnings/setup")
    //       },
    //     },
    //   ]
    // },
    {
      label: "EDR",
      items: [
        {
          label: "Earnings",
          command: () => {
            navigate("/company/earnings/setup")
          },
        },
        {
          label: "Deductions",
          command: () => {
            navigate("/company/deductions/setup")
          },
        },
        {
          label: "Reimbursements",
          command: () => {
            navigate("/company/reimbursements/setup")
          },
        },
      ]
    },
  ];

  return {
    CompanyMenu: ArrayData
  }
}
